import React from 'react';
import { useSelector } from 'react-redux';

import { Button } from '@mui/material';

import useWindowIsMobile from '@/utils/hooks/useWindowIsMobile';

import styles from '@/views/components/ManageButton/ManageButton.module.scss';

const ManageButton = ({ label, forwardRef, open, handleToggle, disabled = false, style }) => {
	const { dict } = useSelector((state) => state.app);

	const isMobile = useWindowIsMobile(991);

	const ThreeDots = () => (
		<i className='three-dots'>
			<svg
				width='20'
				height='20'
				viewBox='0 0 20 20'
				fill='currentColor'
			><path d='M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z' />
			</svg>
	
		</i>
	);

	return (
		<Button
			ref={ forwardRef }
			id='composition-button'
			aria-controls={ open ? 'composition-menu' : undefined }
			aria-expanded={ open ? 'true' : undefined }
			aria-haspopup='true'
			onClick={ handleToggle }
			className={ isMobile ? `${ styles['manage-button__mobile'] } button__white` : `${ styles['manage-button'] } mui__button` }
			disabled={ disabled }
			style={ style }
		>
			{label ? label : dict.dictionary.list.manage}
			{ isMobile ? (
				open ? <i className='icon-arrow-up-full' /> : <i className='icon-arrow-down-full' />
			) : (
				<ThreeDots />
			) }
		</Button>
	);
};

export default ManageButton;